// Landing page translations - World-class copy
export const landingTranslations = {
  nb: {
    // Hero
    hero: {
      headline1: 'Juridisk sakshåndtering',
      headline2: 'drevet av AI',
      subheadline: 'Automatiser rutinearbeid. Generer dokumenter på sekunder.',
      subheadline2: 'Fokuser på det som betyr mest — klientene dine.',
      cta: 'Kom i gang gratis',
      demo: 'Se demo',
    },
    
    // Hero Linear2 - World-class Norwegian
    heroLinear: {
      line1: ['AI-plattformen', 'for'],
      line2: ['moderne', 'advokatfirmaer'],
      sub1: ['Automatiser', 'saksbehandling,', 'dokumentanalyse'],
      sub2: ['og', 'e-posthåndtering.'],
      cta: 'Kom i gang',
      demo: 'Se demo',
    },
    
    // Nav
    nav: {
      features: 'Funksjoner',
      customers: 'Kunder',
      pricing: 'Priser',
      login: 'Logg inn',
      register: 'Registrer',
    },
    
    // Screenshot/App content
    app: {
      work: 'Arbeid',
      overview: 'Oversikt',
      inbox: 'Innboks',
      workQueue: 'Arbeidskø',
      aiWorkspace: 'AI Workspace',
      cases: 'Saker',
      clients: 'Klienter',
      documents: 'Dokumenter',
      admin: 'Admin',
      timeTracking: 'Timeføring',
      invoicing: 'Fakturering',
      goodMorning: 'God morgen',
      howCanIHelp: 'Hvordan kan jeg hjelpe deg i dag?',
      analyzeContract: 'Analyser kontrakt',
      writeMotion: 'Skriv prosesskriv',
      searchCaseLaw: 'Søk rettspraksis',
      draftResponse: 'Svar på e-post',
      askAnything: 'Spør meg om hva som helst...',
      incomingEmails: 'Innkommende e-poster',
      sortBy: 'Sorter etter:',
      newest: 'Nyeste',
      aiAnalyzed: 'AI analysert',
      urgent: 'Haster',
      important: 'Viktig',
      caseOverview: 'Saksoversikt',
      deadline: 'Frist',
      activeCases: 'Aktive saker',
      activeTimer: 'Aktiv timer',
      todayHours: 'Timer i dag',
      weekHours: 'Denne uken',
      billablePercent: 'Fakturerbart',
    },
    
    // Email examples
    emails: {
      sender1: 'Advokatfirma Berg AS',
      subject1: 'Angående fusjon - due diligence dokumenter',
      sender2: 'Oslo Tingrett',
      subject2: 'Innkalling til hovedforhandling - Sak 23-123456',
      sender3: 'Klient: Nordic Invest',
      subject3: 'Oppfølging av kontraktsforhandlinger',
    },
    
    // Features section
    featuresSection: {
      caseManagement: 'Sakshåndtering',
      caseHeadline: 'Sett retningen med\noversiktlige saker og frister',
      aiPowered: 'AI-drevet',
      aiHeadline: 'Analyser dokumenter med\nkunstig intelligens',
      efficiency: 'effektivitet',
      smartInbox: 'Smart innboks',
      inboxHeadline: 'E-post som sorterer seg selv',
      timeTracking: 'Timeføring',
      timeHeadline: 'Registrer tid uten friksjon',
      clientPortal: 'Klientportal',
      portalHeadline: 'Gi klienter det de vil ha',
      security: 'Sikkerhet',
      securityHeadline: 'Bygget for advokatenes krav',
    },
    
    // Animation content
    animation: {
      cases: {
        title: 'Aktive saker',
        count: '13 saker',
        items: [
          { title: 'Hansen vs. NordicTech AS', status: 'AI analyserer' },
          { title: 'Eiendomsoverdragelse Fjordvik', status: 'Utkast klart' },
          { title: 'Due Diligence - TechStart', status: 'Under arbeid' },
        ],
        notification: 'Dokument generert automatisk',
      },
      time: {
        title: 'Timeregistrering',
        badge: '+12% denne uken',
        stats: [
          { label: 'I DAG', value: '6.5', unit: 'timer' },
          { label: 'DENNE UKEN', value: '32.5', unit: 'timer' },
          { label: 'FAKTURERBART', value: '94', unit: '%' },
        ],
        goal: 'Ukentlig mål',
        goalValue: '32.5 / 40 timer',
      },
      ai: {
        title: 'AI Workspace',
        userMessage: 'Lag et utkast til aksjekjøpsavtale for TechStart-oppkjøpet',
        aiLabel: 'Lexy AI',
        aiResponse: 'Jeg har analysert Due Diligence-rapporten og identifisert følgende nøkkelpunkter for avtalen: Kjøpesum på NOK 45M, lock-up periode på 24 mnd for grunnleggerne, og standard garantiklausuler. Skal jeg generere et komplett utkast?',
        placeholder: 'Spør Lexy om hva som helst...',
      },
      sidebar: {
        cases: 'Saker',
        time: 'Timer',
        messages: 'Meldinger',
        ai: 'AI Workspace',
      },
      phases: ['Saker', 'Timer', 'AI'],
    },
    
    // Stats
    stats: {
      docAnalysis: 'Raskere dokumentanalyse',
      lawFirms: 'Advokatfirmaer',
      casesHandled: 'Saker håndtert',
      savedPerWeek: 'Spart per uke',
    },
    
    // Testimonial
    testimonial: {
      quote: 'Lexy har transformert hvordan vi jobber. Vi sparer flere timer hver dag på dokumentgjennomgang og saksadministrasjon. AI-funksjonene er imponerende presise.',
      name: 'Maria Hansen',
      title: 'Partner, Strand Advokat',
    },
    
    // Pricing
    pricing: {
      label: 'Priser',
      title: 'Enkel, transparent prising',
      subtitle: '14 dagers gratis prøveperiode. Ingen kredittkort.',
      starter: 'Starter',
      starterDesc: 'For mindre team og enkeltadvokater',
      starterPrice: '990',
      professional: 'Professional',
      professionalDesc: 'For voksende firmaer med høye krav',
      professionalPrice: '2 490',
      recommended: 'Anbefalt',
      perMonth: 'kr/mnd',
      startFree: 'Start gratis',
      startTrial: 'Start gratis prøveperiode',
      features: {
        starter: ['Opptil 5 brukere', '50 aktive saker', 'AI-analyse (100/mnd)', 'Dokumenthåndtering', 'E-post support'],
        professional: ['Ubegrenset brukere', 'Ubegrenset saker', 'Ubegrenset AI', 'Klientportal inkludert', 'Prioritert support', 'API-tilgang'],
      },
    },
    
    // Final CTA
    finalCta: {
      title: 'Klar til å spare tid?',
      subtitle: 'Bli med 50+ advokatfirmaer som allerede bruker Lexy.',
      subtitle2: '14 dager gratis. Ingen binding.',
      button: 'Start gratis nå',
    },
    
    // Social proof
    social: {
      title: 'Brukes av ledende advokatfirmaer',
      companies: ['Kviteberg', 'Hansen & Co', 'Nordisk Advokat', 'Fjord Legal', 'Berg Partners'],
    },
    
    // Features (old)
    features: {
      title: 'Alt du trenger',
      subtitle: 'En komplett løsning for moderne juridisk arbeid. Spar tid, reduser feil, imponér klienter.',
      label: 'Plattformen',
      items: [
        { title: 'Sakshåndtering', desc: 'Organiser saker, frister og team. Aldri gå glipp av en deadline igjen.' },
        { title: 'Klientportal', desc: 'Gi klienter tilgang til saksstatus, dokumenter og sikker kommunikasjon.' },
        { title: 'Kommunikasjon', desc: 'E-post, meldinger og notater — alt samlet i saken det tilhører.' },
        { title: 'AI Dokumentanalyse', desc: 'Last opp kontrakter og få umiddelbar analyse av risikoer og nøkkelpunkter.' },
        { title: 'AI Skriveassistent', desc: 'Generer utkast til prosesskriv, kontrakter og brev på sekunder.' },
        { title: 'Compliance & Sikkerhet', desc: 'GDPR-compliant, kryptert lagring, og full revisjonsspor.' },
      ],
    },
    
    // CTA
    cta: {
      title: 'Klar til å prøve?',
      subtitle: 'Start gratis i dag. Ingen kredittkort nødvendig.',
      button: 'Kom i gang gratis',
    },
    
    // Footer
    footer: {
      privacy: 'Personvern',
      terms: 'Vilkår',
      contact: 'Kontakt',
    },
  },
  
  en: {
    // Hero - World-class English copy
    hero: {
      headline1: 'Legal practice management',
      headline2: 'powered by AI',
      subheadline: 'Automate the mundane. Generate documents in seconds.',
      subheadline2: 'Focus on what actually matters — your clients.',
      cta: 'Get started free',
      demo: 'Watch demo',
    },
    
    // Hero Linear2 - World-class English
    heroLinear: {
      line1: ['The', 'AI', 'platform', 'for'],
      line2: ['modern', 'law', 'firms'],
      sub1: ['Automate', 'case', 'management,', 'document', 'analysis'],
      sub2: ['and', 'email', 'workflows.'],
      cta: 'Get started',
      demo: 'Watch demo',
    },
    
    // Nav
    nav: {
      features: 'Features',
      customers: 'Customers',
      pricing: 'Pricing',
      login: 'Log in',
      register: 'Sign up',
    },
    
    // Screenshot/App content
    app: {
      work: 'Work',
      overview: 'Overview',
      inbox: 'Inbox',
      workQueue: 'Work Queue',
      aiWorkspace: 'AI Workspace',
      cases: 'Matters',
      clients: 'Clients',
      documents: 'Documents',
      admin: 'Admin',
      timeTracking: 'Time Tracking',
      invoicing: 'Invoicing',
      goodMorning: 'Good morning',
      howCanIHelp: 'How can I help you today?',
      analyzeContract: 'Analyze contract',
      writeMotion: 'Draft motion',
      searchCaseLaw: 'Search case law',
      draftResponse: 'Reply to email',
      askAnything: 'Ask me anything...',
      incomingEmails: 'Incoming emails',
      sortBy: 'Sort by:',
      newest: 'Newest',
      aiAnalyzed: 'AI analyzed',
      urgent: 'Urgent',
      important: 'Important',
      caseOverview: 'Matter overview',
      deadline: 'Deadline',
      activeCases: 'Active matters',
      activeTimer: 'Active timer',
      todayHours: 'Hours today',
      weekHours: 'This week',
      billablePercent: 'Billable',
    },
    
    // Email examples
    emails: {
      sender1: 'Berg Law Firm LLP',
      subject1: 'Re: Merger — due diligence documents',
      sender2: 'District Court',
      subject2: 'Notice of hearing — Case No. 23-123456',
      sender3: 'Client: Nordic Invest',
      subject3: 'Follow-up on contract negotiations',
    },
    
    // Features section
    featuresSection: {
      caseManagement: 'Matter Management',
      caseHeadline: 'Set the direction with\nclear matters and deadlines',
      aiPowered: 'AI-Powered',
      aiHeadline: 'Analyze documents with\nartificial intelligence',
      efficiency: 'efficiency',
      smartInbox: 'Smart Inbox',
      inboxHeadline: 'Email that sorts itself',
      timeTracking: 'Time Tracking',
      timeHeadline: 'Track time without friction',
      clientPortal: 'Client Portal',
      portalHeadline: 'Give clients what they want',
      security: 'Security',
      securityHeadline: 'Built for legal standards',
    },
    
    // Animation content - Natural English
    animation: {
      cases: {
        title: 'Active matters',
        count: '13 matters',
        items: [
          { title: 'Hansen v. NordicTech Inc.', status: 'AI reviewing' },
          { title: 'Fjordvik Property Transfer', status: 'Draft ready' },
          { title: 'TechStart Due Diligence', status: 'In progress' },
        ],
        notification: 'Document auto-generated',
      },
      time: {
        title: 'Time tracking',
        badge: '+12% this week',
        stats: [
          { label: 'TODAY', value: '6.5', unit: 'hours' },
          { label: 'THIS WEEK', value: '32.5', unit: 'hours' },
          { label: 'BILLABLE', value: '94', unit: '%' },
        ],
        goal: 'Weekly target',
        goalValue: '32.5 / 40 hours',
      },
      ai: {
        title: 'AI Workspace',
        userMessage: 'Draft a share purchase agreement for the TechStart acquisition',
        aiLabel: 'Lexy AI',
        aiResponse: "I've reviewed the Due Diligence report and identified key terms: NOK 45M purchase price, 24-month founder lock-up, and standard warranty provisions. Want me to generate the full draft?",
        placeholder: 'Ask Lexy anything...',
      },
      sidebar: {
        cases: 'Matters',
        time: 'Time',
        messages: 'Messages',
        ai: 'AI Workspace',
      },
      phases: ['Matters', 'Time', 'AI'],
    },
    
    // Stats
    stats: {
      docAnalysis: 'Faster document analysis',
      lawFirms: 'Law firms',
      casesHandled: 'Matters handled',
      savedPerWeek: 'Saved per week',
    },
    
    // Testimonial
    testimonial: {
      quote: 'Lexy has transformed how we work. We save hours every day on document review and case administration. The AI features are impressively accurate.',
      name: 'Maria Hansen',
      title: 'Partner, Strand Law',
    },
    
    // Pricing
    pricing: {
      label: 'Pricing',
      title: 'Simple, transparent pricing',
      subtitle: '14-day free trial. No credit card required.',
      starter: 'Starter',
      starterDesc: 'For small teams and solo practitioners',
      starterPrice: '99',
      professional: 'Professional',
      professionalDesc: 'For growing firms with high demands',
      professionalPrice: '249',
      recommended: 'Recommended',
      perMonth: '/month',
      startFree: 'Start free',
      startTrial: 'Start free trial',
      features: {
        starter: ['Up to 5 users', '50 active matters', 'AI analysis (100/mo)', 'Document management', 'Email support'],
        professional: ['Unlimited users', 'Unlimited matters', 'Unlimited AI', 'Client portal included', 'Priority support', 'API access'],
      },
    },
    
    // Final CTA
    finalCta: {
      title: 'Ready to save time?',
      subtitle: 'Join 50+ law firms already using Lexy.',
      subtitle2: '14 days free. No commitment.',
      button: 'Start free now',
    },
    
    // Social proof
    social: {
      title: 'Trusted by leading law firms',
      companies: ['Kviteberg', 'Hansen & Co', 'Nordic Legal', 'Fjord Law', 'Berg Partners'],
    },
    
    // Features - Punchy English copy
    features: {
      title: 'Everything you need',
      subtitle: 'A complete solution for modern legal work. Save time, reduce errors, impress clients.',
      label: 'Platform',
      items: [
        { title: 'Matter Management', desc: 'Organize matters, deadlines, and teams. Never miss a deadline again.' },
        { title: 'Client Portal', desc: 'Give clients access to case status, documents, and secure communication.' },
        { title: 'Communication', desc: 'Email, messages, and notes — all collected in the relevant matter.' },
        { title: 'AI Document Analysis', desc: 'Upload contracts and get instant analysis of risks and key points.' },
        { title: 'AI Writing Assistant', desc: 'Generate drafts for motions, contracts, and letters in seconds.' },
        { title: 'Compliance & Security', desc: 'GDPR-compliant, encrypted storage, and full audit trail.' },
      ],
    },
    
    // CTA
    cta: {
      title: 'Ready to try it?',
      subtitle: 'Start free today. No credit card required.',
      button: 'Get started free',
    },
    
    // Footer
    footer: {
      privacy: 'Privacy',
      terms: 'Terms',
      contact: 'Contact',
    },
  }
};

export type Language = 'nb' | 'en';
export type LandingTranslations = typeof landingTranslations.nb;
